import React from 'react';
import { Chip } from '@mui/material';
import type { ClaimStatus } from '../types/billing';

export interface StatusChipProps {
  status: ClaimStatus;
  queuePosition?: number | null;
}

type MuiChipColor = 'default' | 'info' | 'success' | 'error' | 'warning';

export const STATUS_LABEL: Record<ClaimStatus, string> = {
  STAGED: 'Imported',
  DISPATCHED: 'Sent to BETHY',
  OA_DRAFT_CREATED: 'OA Draft',
  SUBMITTED: 'Submitted',
  FAILED: 'Failed',
  NEEDS_REVIEW: 'Needs Review',
  SKIPPED: 'Skipped',
  MANUALLY_COMPLETED: 'Manually completed',
};

const STATUS_COLOR: Record<ClaimStatus, MuiChipColor> = {
  STAGED: 'default',
  DISPATCHED: 'info',
  OA_DRAFT_CREATED: 'info',
  SUBMITTED: 'success',
  FAILED: 'error',
  NEEDS_REVIEW: 'warning',
  SKIPPED: 'default',
  MANUALLY_COMPLETED: 'success',
};

const StatusChip: React.FC<StatusChipProps> = ({ status, queuePosition }) => {
  if (status === 'DISPATCHED' && queuePosition === 0) {
    return <Chip label="Working" color="warning" size="small" variant="filled" />;
  }
  if (status === 'DISPATCHED' && typeof queuePosition === 'number' && queuePosition > 0) {
    return <Chip label={`Sent to BETHY · #${queuePosition}`} color="info" size="small" variant="filled" />;
  }
  if (status === 'MANUALLY_COMPLETED') {
    return (
      <Chip
        label={STATUS_LABEL[status]}
        color="success"
        size="small"
        variant="outlined"
      />
    );
  }
  return (
    <Chip
      label={STATUS_LABEL[status]}
      color={STATUS_COLOR[status]}
      size="small"
      variant="filled"
    />
  );
};

export default StatusChip;
